/** Human label for a workspace's location count, e.g. "1 location" / "3 locations". */
export function locationLabel(count: number): string {
  return `${count} ${count === 1 ? 'location' : 'locations'}`;
}
